<template>
  <v-dialog v-model="dialog" width="500">
    <v-img
      v-if="data && data.filename && data.date"
      :src="`${server}/images/id-photos?q=${data.filename}&date=${data.date}`"
      width="500"
    >
      <v-row row justify-end>
        <v-btn
          class="ma-2"
          variant="outlined"
          icon
          color="red"
          @click="dialog = false"
        >
          <v-icon> mdi-close </v-icon>
        </v-btn>
      </v-row>
    </v-img>
    <v-img v-else :src="`https://portal.lekotech.com/logo_small.png`">
      <v-row row justify-end>
        <v-btn
          class="ma-2"
          variant="outlined"
          icon
          color="red"
          @click="dialog = false"
        >
          <v-icon> mdi-close </v-icon>
        </v-btn>
      </v-row>
    </v-img>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    data: {},
  }),
  computed: {
    server() {
      return this.$serverUri;
    },
  },
  methods: {
    showImage(data) {
      this.data.filename = data.filename;
      this.data.date = data.date;
      this.dialog = true;
    },
  },
};
</script>
